export default function Preloader() {
  return (
    <div className="preloader">
      <div className="preloader-content">
        <div className="preloader-spinner"></div>
        <img
          className="preloader-logo"
          src={require("../../assets/imgs/abg-logo.png")}
          width="140px"
          alt="ABG Logo"
        />
      </div>
    </div>
  );
}
